<div class="d-flex justify-content-between align-items-center">
  <div class="d-flex align-items-center gap-3 w-100">
    <div class="flex-fill"></div>
  </div>
</div>

<div class="filters-box" [ngClass]="{ 'group-rates': isGroupRates, 'rental-rates': !isGroupRates }">
  <mat-form-field2
    class="field-categories"
    [showLabel]="false"
    i18n-matTooltip
    matTooltip="Filter the below rates by category."
    matTooltipPosition="below"
  >
    <mat-select [formControl]="categoryControl" i18n-placeholder placeholder="Category">
      <mat-option value="*" i18n>All categories</mat-option>
      <mat-option *ngFor="let category of categories$ | async" [value]="category">{{ category }}</mat-option>
    </mat-select>
  </mat-form-field2>

  <mat-form-field2
    class="field-period"
    [showLabel]="false"
    i18n-matTooltip
    matTooltip="Filter the below rates by period."
    matTooltipPosition="below"
  >
    <app-mat-daterange-input placeholder="Rate Period" [formControl]="periodControl"></app-mat-daterange-input>
  </mat-form-field2>

  <app-select-search
    *ngIf="isGroupRates"
    [inline]="true"
    bindValue="id"
    bindLabel="name"
    [items]="filteredRentals$ | async"
    [ctrl]="rentalsControl"
    i18n-placeholder
    placeholder="Rentals"
  >
  </app-select-search>

  <app-cancel-filters [isFiltering]="isFiltering" (clear)="clearFilters()"></app-cancel-filters>
  <div class="flex-fill"></div>
  <div class="text-black-50">
    <div *ngIf="isAnySelected()">{{ getSelected().length }} <ng-container i18n>items are selected</ng-container>.</div>
  </div>
  <div class="flex-fill"></div>

  <app-table-search [ctrl]="searchControl" #search></app-table-search>
  <button
    type="button"
    class="btn btn-secondary-danger"
    [disabled]="!isAnySelected() || isDeleting || !groupRatesLoaded || (1 | isReadonlyRole)"
    (click)="onDelete()"
  >
    <i class=" {{ isDeleting ? 'far fa-spinner fa-spin' : 'cs-icon cs-icon-trash' }}"></i>
    <ng-container *ngIf="isAllSelected(false)"> <ng-container i18n>Delete All Rates</ng-container> </ng-container>
    <ng-container *ngIf="!isAllSelected(false)"><ng-container i18n>Delete</ng-container></ng-container>
  </button>

  <div class="btn-group" dropdown [isDisabled]="1 | isReadonlyRole">
    <button type="button" class="btn btn-secondary-info dropdown-toggle" dropdownToggle>
      <span class="{{ rateIcon }}"></span> Add {{ rateLabel }}s
    </button>
    <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu>
      <li>
        <button
          type="button"
          (click)="onAddStandardRate()"
          i18n-matTooltip
          matTooltip="Standard rates are flat, constant rates which do not change over time."
          matTooltipPosition="left"
        >
          <i class="{{ rateIcon }}"></i> <ng-container i18n>Add Standard</ng-container> {{ rateLabel }}
        </button>
      </li>
      <li>
        <button
          type="button"
          (click)="onAddDynamicRate()"
          i18n-matTooltip
          matTooltip="Dynamic rates will gradually and automatically adjust from a low rate to a high rate as your overall rental occupancy level changes. They can also instantly update your channels as the rate changes."
          matTooltipPosition="left"
        >
          <i class="{{ rateIcon }}"></i> <ng-container i18n>Add Dynamic</ng-container> {{ rateLabel }}
        </button>
      </li>
    </ul>
  </div>
</div>

<div class="table-holder table-responsive">
  <table class="table table-default table-striped">
    <mat-table #table matSort matSortActive="period" matSortDirection="asc" [dataSource]="dataSource">
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            [checked]="selection.hasValue() && isAllSelected(isSelectAllRenderedItems)"
            [indeterminate]="selection.hasValue() && !isAllSelected(isSelectAllRenderedItems)"
            [disabled]="!isGroupRates && !(hasRentalRates | call : dataSource.data)"
            (change)="onMasterToggle($event?.checked)"
            class="master-toggle"
          >
          </mat-checkbox>
          <div class="btn-group master-toggle-group" dropdown container="body" [isDisabled]="!dataSource.data?.length">
            <div dropdownToggle>
              <i class="fa fa-caret-down ml-2"></i>
            </div>
            <ul class="dropdown-menu" *dropdownMenu>
              <li>
                <button type="button" (click)="onSelectAll(true)"><ng-container i18n>All</ng-container></button>
              </li>
              <li>
                <button type="button" (click)="onSelectAll(false)">
                  <ng-container i18n>All Visible</ng-container>
                </button>
              </li>
              <li>
                <button type="button" (click)="onMasterToggle(false)"><ng-container i18n>None</ng-container></button>
              </li>
            </ul>
          </div>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
            [disabled]="!isGroupRates && (isGroupRate | call : row)"
          >
          </mat-checkbox>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header><ng-container i18n>Name</ng-container></mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.name }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="category">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          <span
            i18n-matTooltip
            matTooltip="Rate categories are used to group multiple rates together. Rates in a Rate Category cannot overlap. When updating a channel you push a single rate category. All rates in that category will be pushed to the channel."
            matTooltipPosition="above"
          >
            <ng-container i18n>Category</ng-container> <i class="fas fa-info-circle"></i>
          </span>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ getRateCategory | call : element }}
          <b *ngIf="element.type === 'dynamic'" matTooltip="Dynamic Rate" matTooltipPosition="right">(D)</b>
          <b *ngIf="element.type === 'promotion'" matTooltip="Promotional Rate" matTooltipPosition="right">(P)</b>
          <b *ngIf="!isGroupRates && (isGroupRate | call : element)" matTooltip="Group Rate" matTooltipPosition="right"
            >(G)</b
          >
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="rentals" *ngIf="isGroupRates">
        <mat-header-cell *matHeaderCellDef mat-sort-header><ng-container i18n>Rentals</ng-container></mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          [matTooltip]="getRentalsTooltip | call : element.rentalIds"
          matTooltipPosition="above"
        >
          {{ element.rentalIds.length }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="period">
        <mat-header-cell *matHeaderCellDef mat-sort-header
          ><ng-container i18n>Rate Period</ng-container></mat-header-cell
        >
        <mat-cell *matCellDef="let element">
          {{ element.start | epochUTC : 'MMM D, YYYY' }} - {{ element.end | epochUTC : 'MMM D, YYYY' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="nightly">
        <mat-header-cell *matHeaderCellDef mat-sort-header><ng-container i18n>Nightly</ng-container></mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div
            class="text-truncate"
            [matTooltip]="
              element.type === 'dynamic'
                ? (element.lowRate | rate : currency : false) + ' - ' + (element.highRate | rate : currency : false)
                : element.nightly
                ? (element.nightly | rate : currency : false)
                : '...'
            "
          >
            <ng-template [ngTemplateOutlet]="element.type === 'dynamic' ? range : nightly"></ng-template>

            <ng-template #range>
              {{ element.lowRate | rate : currency : false }} -
              {{ element.highRate | rate : currency : false }}
            </ng-template>
            <ng-template #nightly>
              {{ element.nightly ? (element.nightly | rate : currency : false) : '...' }}
            </ng-template>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="weekly">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Weekly</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.weekly ? (element.weekly | rate : currency : false) : '...' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="monthly">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Monthly</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.monthly ? (element.monthly | rate : currency : false) : '...' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="minimumStay">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Min Stay</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.minimumStay }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="touch">
        <mat-header-cell *matHeaderCellDef mat-sort-header><ng-container i18n>Updated</ng-container></mat-header-cell>
        <mat-cell *matCellDef="let element" [matTooltip]="element.touch | epoch : 'datetime'">
          {{ element.touch | epoch : 'date' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef i18n> EDIT</mat-header-cell>

        <mat-cell *matCellDef="let element">
          <div
            dropdown
            placement="bottom right"
            container="body"
            [isDisabled]="1 | isReadonlyRole"
            *ngIf="isGroupRates || !(isGroupRate | call : element)"
          >
            <div dropdownToggle (click)="$event.stopPropagation()" class="btn-group btn-ellips-holder">
              <a class="btn-ellips">
                <i class="fas fa-ellipsis-v"></i>
              </a>
            </div>
            <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
              <li>
                <button (click)="onEdit(element)" type="button">
                  <i class="fal fa-edit"></i><ng-container i18n>Edit</ng-container>
                </button>
              </li>
              <li>
                <button (click)="onDelete(element)" type="button" [disabled]="!groupRatesLoaded">
                  <i class="cs-icon cs-icon-trash"></i><ng-container i18n>Delete</ng-container>
                </button>
              </li>
            </ul>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="onEdit(row)"
        class="clickable"
        [matTooltip]="getRowTooltip | call : row"
        matTooltipPosition="above"
      >
      </mat-row>
    </mat-table>

    <mat-paginator2
      #paginator
      [length]="dataSource?.data?.length"
      [class.hidden]="isEmptyTable$ | async"
      (page)="onPageChange($event)"
      [pageSize]="savedPageSize"
      [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
      [showFirstLastButtons]="true"
    >
    </mat-paginator2>

    <app-empty-table *ngIf="isEmptyTable$ | async" [type]="tableType" class="bg-white"></app-empty-table>
  </table>
</div>
